import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-backtop",
  "use": "icon-backtop-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-backtop\"><defs><style>#icon-backtop .cls-1{fill:#30aa9f;}</style></defs><path class=\"cls-1\" d=\"M17.6,39.74546,55.78182,3.27273a11.77291,11.77291,0,0,1,16.2909,0L110.4,39.74546a10.753,10.753,0,0,1,0,15.70909,12.02783,12.02783,0,0,1-16.43637,0L75.63637,37.96363v78.9091a11.648,11.648,0,0,1-23.27273,0V37.96363L34.03637,55.49091a12.02782,12.02782,0,0,1-16.43636,0A10.79492,10.79492,0,0,1,17.6,39.74546Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol